import { DeleteUserRequestReasonEnum } from "shared/services/api/store";

export const CancelMembershipLogReason = DeleteUserRequestReasonEnum;
export type CancelMembershipLogReason = typeof CancelMembershipLogReason[keyof typeof CancelMembershipLogReason]
